import React from "react"

const LinkIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 17 17">
    <path
      d="M3.912 7c.21 0 .421.087.58.262a.818.818 0 0 1 .245.575c0 .21-.088.419-.246.576L3.456 9.442a2.868 2.868 0 0 0-.842 2.04c0 .785.298 1.5.842 2.041.544.541 1.263.837 2.053.837s1.509-.296 2.052-.837l1.035-1.029a.828.828 0 0 1 .58-.244c.21 0 .42.087.578.244a.818.818 0 0 1 .246.576c0 .21-.088.418-.246.575l-1.035 1.03c-.86.854-2 1.325-3.193 1.325a4.516 4.516 0 0 1-3.193-1.326A4.463 4.463 0 0 1 1 11.5a4.41 4.41 0 0 1 1.35-3.174l.983-1.082A.828.828 0 0 1 3.913 7zm8.58 1.604l1.053-1.001a2.898 2.898 0 0 0 .842-2.055c0-.79-.298-1.51-.842-2.054a2.86 2.86 0 0 0-2.052-.843 2.86 2.86 0 0 0-2.051.843L8.407 4.53a.825.825 0 0 1-.578.246.825.825 0 0 1-.58-.246c-.332-.316-.332-.826 0-1.16l1.035-1.035A4.497 4.497 0 0 1 11.476 1c1.21 0 2.332.474 3.191 1.335A4.51 4.51 0 0 1 16 5.53a4.51 4.51 0 0 1-1.333 3.196l-1.034 1.036a.804.804 0 0 1-1.14 0 .827.827 0 0 1-.246-.58c0-.21.088-.421.246-.58zM10.197 6c.017 0 .017 0 0 0 .222.017.41.103.564.24.154.153.24.358.24.563 0 .206-.086.41-.24.565l-3.404 3.401a.785.785 0 0 1-1.112 0c-.325-.307-.325-.803 0-1.128L9.63 6.239A.805.805 0 0 1 10.196 6z"
      stroke="currentColor"
      fillRule="nonzero"
      fill="currentColor" />
  </svg>
)

export default LinkIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/LinkIcon.jsx